export default {
    app: {
        apiUrl: 'http://int-energy01.ua.pnnsoft.com:8001/api',
        reportsApiUrl: 'http://int-energy01.ua.pnnsoft.com:8003/api',
        dataCollectionApiUrl: 'http://int-energy01.ua.pnnsoft.com:8002/api',
        modulesHostApiUrl: 'https://int-energy01.ua.pnnsoft.com:8004/api',
        openStreetApiUrl: 'https://nominatim.openstreetmap.org/',
    },
    dataCollection: {
        maxIntervalMinutes: 60,
        minIntervalMinutes: 5,
        stepMinutes: 5,
    },
    upload: {
        supportedImageTypes: ['image/jpeg', 'image/jpg', 'image/png', 'image/webp'], // webp is added
    },
    image: {
        authBackground: 'bg-5',
    },
    durations: {
        notification: 4.5,
        searchDelay: 500,
    },
    dates: {
        minYearDate: 1970,
    },
    logs: {
        isDebug: true,
        logLevel: 'trace',
        antdWarningsEnabled: false,
    },
};
